import { useEffect, useState } from "react";

// Bootstrap components
import Carousel from "react-bootstrap/Carousel";

// Axios
import axios from "axios";

// Custom Styles
import "./customNavCarousel.styles.scss";

// Assets
import { ReactComponent as CustomPrevIcon } from "../../../assets/img/left-arrow--white.svg";
import { ReactComponent as CustomNextIcon } from "../../../assets/img/right-arrow--white.svg";
// import { ReactComponent as CustomNextIcon } from "../../../assets/img/noun-right-arrow-3465428.svg";

function CustomNavCarousel() {
  const [notices, setNotices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState({ error: false, message: "" });
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/graphql`,
          {
            query: `
            {
              avisos{
                data{
                  attributes{
                    Aviso
                  }
                }
              }
            }
          `,
          }
        );
        setNotices(response.data.data.avisos.data);
      } catch (error) {
        console.error("Error fetching data:", error);
        setError({ error: true, message: error.message || error.toString() });
      } finally {
        setLoading(false);
      }
      // console.log(response.data.data);
    };

    fetchData();
  }, []);
  if (loading) {
    return (
      <Carousel
        className="custom-nav__carousel"
        interval={3000}
        prevIcon={<CustomPrevIcon />} // Custom previous arrow icon
        nextIcon={<CustomNextIcon />} // Custom next arrow icon
        indicators={false} // Disable pagination indicators
      >
        <Carousel.Item>
          <h6>Cargando información...</h6>
        </Carousel.Item>
      </Carousel>
    );
  }
  if (error.error) {
    return (
      <Carousel
        className="custom-nav__carousel"
        interval={3000}
        prevIcon={<CustomPrevIcon />} // Custom previous arrow icon
        nextIcon={<CustomNextIcon />} // Custom next arrow icon
        indicators={false} // Disable pagination indicators
      >
        <Carousel.Item>
          <h6>No se pudo cargar la información en este momento ⌛️</h6>
        </Carousel.Item>
      </Carousel>
    );
  }
  return (
    <Carousel
      className="custom-nav__carousel"
      interval={3000}
      prevIcon={<CustomPrevIcon />} // Custom previous arrow icon
      nextIcon={<CustomNextIcon />} // Custom next arrow icon
      indicators={false} // Disable pagination indicators
    >
      {/* Carousel items */}
      {notices.map((item, key) => (
        <Carousel.Item key={key}>
          <h6>{item.attributes.Aviso}</h6>
        </Carousel.Item>
      ))}

      {/* <Carousel.Item>
        <h6>Regreso a clases 12 de Agosto Periodo Escolar</h6>
      </Carousel.Item>
      <Carousel.Item>
        <h6>Último día para pago de exámenes extraordinarios 05 Agosto 2024</h6>
      </Carousel.Item> */}
    </Carousel>
  );
}

export default CustomNavCarousel;
